import { useMemo, useState } from "react";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

const cmp = (a, b) => {
  const ea = a === null || a === undefined || a === "", eb = b === null || b === undefined || b === "";
  if (ea || eb) return ea && eb ? 0 : ea ? 1 : -1;
  if (typeof a === "number" && typeof b === "number") return a - b;
  if (typeof a === "boolean" || typeof b === "boolean") return Number(a) - Number(b);
  return String(a).localeCompare(String(b), "it", { numeric: true, sensitivity: "base" });
};

export const sortRows = (rows, key, dir, getters = {}) => {
  if (!key) return rows;
  const get = getters[key] || ((r) => r[key]);
  const out = [...rows].sort((x, y) => {
    const a = get(x), b = get(y);
    const empty = (v) => v === null || v === undefined || v === "";
    if (empty(a) || empty(b)) return cmp(a, b);
    return dir === "desc" ? -cmp(a, b) : cmp(a, b);
  });
  return out;
};

export const useSort = (rows, getters, initial = { key: null, dir: "asc" }) => {
  const [sort, setSort] = useState(initial);
  const sorted = useMemo(() => sortRows(rows, sort.key, sort.dir, getters), [rows, sort]); // eslint-disable-line react-hooks/exhaustive-deps
  const toggle = (key) => setSort((s) => (s.key === key ? { key, dir: s.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" }));
  return { sorted, sort, toggle };
};

export const SortTh = ({ k, sort, onSort, className = "px-3 py-2", align, children }) => {
  const active = sort.key === k;
  const Icon = !active ? ArrowUpDown : sort.dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <th className={className} aria-sort={active ? (sort.dir === "asc" ? "ascending" : "descending") : "none"}>
      <button type="button" onClick={() => onSort(k)} data-testid={`sort-${k}`}
        className={`inline-flex items-center gap-1 uppercase tracking-wider hover:text-slate-900 ${align === "right" ? "flex-row-reverse" : ""} ${active ? "text-slate-900" : ""}`}>
        {children}<Icon className={`h-3 w-3 shrink-0 ${active ? "opacity-100" : "opacity-40"}`} />
      </button>
    </th>
  );
};
